import vue from 'vue'
import axios from '@/services/axios.js'
import { getHeadersWithAccessToken } from '@/functions'

const state = {
    ticketsOpen: 0,
    hoursSplitTable: [],
    hoursSplitLoading: false,
    hoursSplitTotalLoading: false,
    hoursSplitTotalTable: [],
    hoursSplitSwitchValue: 'Month',
    analyticsLoading: false,
    analyticsTable: [],
    analyticsTotalLoading: false,
    analyticsTotalTable: [],
    analyticsSwitchValue: 'Store',
    analyticsColumns: [],
    analyticsSelectedColumns: ['kpi', 'kpi_ly'],
    analyticsTableHeaders: {},
    tableSortedOn: null,
    stores: []
}

const mutations = {
    'UPDATE_VALUE' (state, payload) {
        vue.set(state, payload.variable, payload.value)
    },
    'SET_HOURS_SPLIT_TABLE' (state, payload) {
        vue.set(state, 'hoursSplitTable', payload)
        vue.set(state, 'hoursSplitLoading', false)
    },
    'SET_HOURS_SPLIT_TOTAL_TABLE' (state, payload) {
        vue.set(state, 'hoursSplitTotalTable', payload)
        vue.set(state, 'hoursSplitTotalLoading', false)
    },
    'SET_ANALYTICS_TABLE' (state, payload) {
        vue.set(state, 'analyticsTable', payload)
        vue.set(state, 'analyticsLoading', false)
    },
    'SET_ANALYTICS_TOTAL_TABLE' (state, payload) {
        vue.set(state, 'analyticsTotalTable', payload)
        vue.set(state, 'analyticsTotalLoading', false)
    },
    'SORT_CHILDS_HOURS_SPLIT' (state, payload) {
        let placeholder = JSON.parse(JSON.stringify(state.hoursSplitTable))
        for (let idx = 0; idx < placeholder.length; idx++) {
            if (payload.order === 'ascending') {
                placeholder[idx].children = placeholder[idx].children.sort((a, b) => (a[payload.prop] > b[payload.prop]) ? 1 : -1)
            } else {
                placeholder[idx].children = placeholder[idx].children.sort((a, b) => (a[payload.prop] > b[payload.prop]) ? -1 : 1)
            }
        }
        vue.set(state, 'hoursSplitTable', placeholder)
    },
    'UPDATE_ANALYTICS_SWITCH' (state, payload) {
        vue.set(state, 'analyticsSwitchValue', payload)
    },
    'SET_ANALYTICS_COLUMNS' (state, payload) {
        vue.set(state, 'analyticsColumns', payload)
    },
    'UPDATE_ANALYTICS_TABLE_HEADERS' (state, payload) {
        let topHeaders = [...new Set(state.analyticsColumns.map(x => x.col_group))]

        let headers = {}
        for (let h of topHeaders) {
            headers[h] = []
        }

        for (let col of state.analyticsColumns) {
            if (col.col_name !== 'x_label' && col.col_select === 'always' && headers[col.col_group].find(x => x.col === col.col_name) === undefined) {
                headers[col.col_group].push({ 'col_name': col.col_name.replace('_' + col.col_group, ''), 'col': col.col_name, 'idx': col.index, 'col_group': col.col_group })
            }
        }
        for (let item of state.analyticsSelectedColumns) {
            for (let col of state.analyticsColumns) {
                if (col.col_name !== 'x_label' && col.col_select === item && headers[col.col_group].find(x => x.col === col.col_name) === undefined) {
                    headers[col.col_group].push({ 'col_name': col.col_name.replace('_' + col.col_group, ''), 'col': col.col_name, 'idx': col.index, 'col_group': col.col_group })
                }
            }
        }
        for (let h of Object.keys(headers)) {
            if (headers[h].length === 0) {
                delete headers[h]
            }
        }
        for (let h of Object.keys(headers)) {
            headers[h] = headers[h].sort((a, b) => (a.idx > b.idx) ? 1 : -1)
        }
        vue.set(state, 'analyticsTableHeaders', headers)
    },
    'SET_TABLE_SORT' (state, payload) {
        vue.set(state, 'tableSortedOn', payload)
    },
    'UPDATE_STORES' (state, payload) {
        vue.set(state, 'stores', payload.stores)
    }
}

const actions = {
    updateStores: ({ commit, rootState }, payload) => {
        let selectedStores = []
        if (Object.keys(payload).includes('stores')) {
            for (let store of rootState.general.stores) {
                if (payload.stores.includes(store.store_id)) {
                    selectedStores.push(store.store_id)
                }
            }
        }
        commit('UPDATE_STORES', { 'stores': selectedStores })
    },
    getHoursSplitTable: ({ commit, rootState }, payload) => {
        let url = '/at/cost/hours_split/' + payload['type'].toLowerCase()
        vue.set(state, 'hoursSplitLoading', true)
        return axios.post(((rootState.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + url, { 'store_id': payload['stores'], 'begin_date': payload['begin_date'], 'end_date': payload['end_date'], 'format': 'aod' }, { headers: getHeadersWithAccessToken() })
            .then(response => {
                let mapping = { 'month': 'store_id', 'store': 'employee', 'employee': 'store_id' }
                let childMapping = { 'month': 'year_month', 'store': 'store_id', 'employee': 'employee' }
                let parents = []
                let childs = []
                for (let row of response.data.data) {
                    if (parseInt(row[mapping[payload.type.toLowerCase()]]) === 0) {
                        row['id'] = row[childMapping[payload['type'].toLowerCase()]]
                        row['children'] = []
                        row['child'] = false
                        parents.push(row)
                    } else {
                        row['id'] = String(row[childMapping[payload['type'].toLowerCase()]]) + '-' + String(childs.length)
                        row['child'] = true
                        childs.push(row)
                    }
                }
                for (let idx = 0; idx < parents.length; idx++) {
                    let c = childs.filter(x => x[childMapping[payload['type'].toLowerCase()]] === parents[idx][childMapping[payload['type'].toLowerCase()]])
                    parents[idx]['children'] = c
                }
                for (let idx = 0; idx < parents.length; idx++) {
                    delete parents[idx][mapping[payload['type'].toLowerCase()]]
                    for (let c = 0; c < parents[idx]['children'].length; c++) {
                        if (payload['type'] !== 'Store') {
                            parents[idx]['children'][c][childMapping[payload['type'].toLowerCase()]] = rootState.general.stores.find(x => x.store_id === parents[idx]['children'][c][mapping[payload['type'].toLowerCase()]]).store_name.substring(0, 14)
                        } else {
                            parents[idx]['children'][c][childMapping[payload['type'].toLowerCase()]] = parents[idx]['children'][c][mapping[payload['type'].toLowerCase()]]
                        }
                    }
                    if (Object.keys(parents[idx]).includes('store_id')) {
                        parents[idx]['store_id'] = rootState.general.stores.find(x => x.store_id === parents[idx]['store_id']).store_name
                    }
                }

                commit('SET_HOURS_SPLIT_TABLE', parents)
            })
            .catch(error => {
                console.log(error)
                commit('SET_HOURS_SPLIT_TABLE', [])
            })
    },
    getHoursSplitTotalTable: ({ commit, rootState }, payload) => {
        vue.set(state, 'hoursSplitTotalLoading', true)
        return axios.post(((rootState.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/cost/hours_split/total', { 'store_id': payload['stores'], 'begin_date': payload['begin_date'], 'end_date': payload['end_date'], 'format': 'aod' }, { headers: getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_HOURS_SPLIT_TOTAL_TABLE', response.data.data)
            })
            .catch(error => {
                console.log(error)
                commit('SET_HOURS_SPLIT_TOTAL_TABLE', [])
            })
    },
    getAnalyticsTable: ({ commit, rootState }, payload) => {
        vue.set(state, 'analyticsLoading', true)
        return axios.post(((rootState.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/cost/analytics/table',
            { 'lfl': payload['lfl'], 'store_id': payload['stores'], 'begin_week': payload['begin_week'], 'end_week': payload['end_week'], 'begin_year': payload['begin_year'], 'end_year': payload['end_year'], 'format': 'aod', 'period_type': payload['period_type'] }, { headers: getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_ANALYTICS_TABLE', response.data.data)
            })
            .catch(error => {
                console.log(error)
                commit('SET_ANALYTICS_TABLE', [])
            })
    },
    getAnalyticsTotalTable: ({ commit, rootState }, payload) => {
        vue.set(state, 'analyticsTotalLoading', true)
        return axios.post(((rootState.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/cost/analytics/table',
            { 'lfl': payload['lfl'], 'store_id': payload['stores'], 'begin_week': payload['begin_week'], 'end_week': payload['end_week'], 'begin_year': payload['begin_year'], 'end_year': payload['end_year'], 'format': 'aod', 'period_type': 'total' }, { headers: getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_ANALYTICS_TOTAL_TABLE', response.data.data)
            })
            .catch(error => {
                console.log(error)
                commit('SET_ANALYTICS_TOTAL_TABLE', [])
            })
    },
    getAnalyticsColunns: ({ commit, rootState }, payload) => {
        return axios.post(((rootState.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/cost/analytics/columns', { 'format': 'aod' }, { headers: getHeadersWithAccessToken() })
            .then(response => {
                commit('SET_ANALYTICS_COLUMNS', response.data.data.sort((a, b) => (a.index > b.index) ? 1 : -1))
            })
            .catch(error => {
                console.log(error)
                commit('SET_ANALYTICS_COLUMNS', [])
            })
    },
    setAnalyticsTableHeaders: ({ commit, rootState }, payload) => {
        commit('UPDATE_ANALYTICS_TABLE_HEADERS')
    }
}

const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
